import {createContext, useContext, useState} from "react";
import {useTable} from "hooks/useTable";
import WidgetApi from "api/widget.api";
import {serviceWidgetDestroy, serviceWidgetSave, serviceWidgetUpdateAction} from "services/widget.service";

const WidgetContext = createContext();

export const WidgetProvider = ({children}) => {

    const translateKey = 'crm.Widget';
    const permission = 'widget';
    const [tableRow, setTableRow] = useState({});
    const [filter, setFilter] = useState({});
    const [modal, setModal] = useState({
        form: false
    });

    const {dataSource, loading: tableLoading, fetchDataSource, handleQuery, query} = useTable(WidgetApi.getIndex);

    const handleFilter = (newFilter) => {
        setFilter(f => ({
            ...f,
            ...newFilter
        }))
    }

    const handleModal = (name, action, data = {}) => {
        setModal(m => ({
            ...m,
            [name]: action
        }))
        setTableRow(data);
    }

    const handleAction = async (id, action = 'is_active') => {
        const res = await serviceWidgetUpdateAction(id, action);
        if (res) await fetchDataSource();
    }

    const handleDelete = async (id) => {
        const res = await serviceWidgetDestroy(id);
        if (res) await fetchDataSource();
    }

    const handleSave = async (form) => {
        const res = await serviceWidgetSave(form)
        if (res) {
            await fetchDataSource();
            return true;
        }
        return false;
    }

    const values = {
        translateKey,
        modal,
        permission,
        filter,
        tableRow,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleModal,
        handleFilter,
        handleAction,
        handleDelete,
        handleSave
    };

    return <WidgetContext.Provider value={values}>
        {children}
    </WidgetContext.Provider>
}

export const useWidgetContext = () => useContext(WidgetContext);
